export default {"src":"https://images-cdn.curipod.com/d-8df0afe6/_next/static/media/wake_county_wcpss.dd36f474.svg","height":67,"width":250};